module.exports = fox._r("images/promo/tutorial/18.png", __webpack_public_path__ + "_/common/images/promo/tutorial/18.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/18.png
// module id = 666
// module chunks = 2